import React from "react";
import DefaultPermissionsIcon from "../../assets/icons/user-access-icons/default-permissions-icon";

const DefaultPermissionsButton = ({ isSlideOpen, onClick }) => {
  console.log('onClick', onClick)
  return (
    <button
      onClick={onClick}
      className={`text-[#245CEA] hover:underline flex items-start gap-1 font-medium text-left ${
        isSlideOpen ? "text-[15px]" : ""
      }`}
    >
      Default Permissions
      <DefaultPermissionsIcon />
    </button>
  );
};

export default DefaultPermissionsButton;
